import React, { useEffect } from "react";
import "./style.less";
import { useSelector, useDispatch } from "react-redux";
import AreaLabel from "../AreaLabel";
import { setSelectedPolygonId } from "../../../../redux/geofence/actions";
import { Element, scroller } from "react-scroll";

function FilteredGeofencesList() {
  const visibleGeofences = useSelector(
    ({ geofence }) => geofence.visibleGeofences
  );
  const selectedPolygonId = useSelector(
    ({ geofence }) => geofence.selectedPolygonId
  );
  const dispatch = useDispatch();
  useEffect(() => {
    const selectedVertex = visibleGeofences
      .map(e => e._id)
      .indexOf(selectedPolygonId);
    if (selectedVertex === -1) {
      return;
    }
    scroller.scrollTo(selectedVertex + "_fence", {
      duration: 1200,
      delay: 100,
      smooth: true,
      containerId: "ScrollToContainer"
    });
  }, [selectedPolygonId, visibleGeofences]);

  return (
    <div id="ScrollToContainer" className="FilteredGeofencesList">
      {visibleGeofences.map((e, index) => (
        <Element name={index + "_fence"} key={index}>
          <AreaLabel
            selected={e._id === selectedPolygonId}
            type={e.properties.fenceCategory}
            area={e.properties.area}
            name={e.properties.name}
            onClick={() => dispatch(setSelectedPolygonId(e._id))}
          />
          <br />
        </Element>
      ))}
    </div>
  );
}

export default FilteredGeofencesList;
